import { LayoutDashboard, Building2, Package, Box, Truck, Ticket, FileBarChart, Settings, Cpu, Users } from "lucide-react";

export const NAV_ITEMS = [
  { href: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { href: "/clients", label: "Organizations", icon: Building2, adminOnly: true },
  { href: "/products", label: "Products", icon: Package },
  { href: "/crates", label: "Wooden Crates", icon: Box },
  { href: "/shipments", label: "Shipments", icon: Truck },
  { href: "/tickets", label: "Tickets", icon: Ticket },
  { href: "/sticks", label: "Sticks", icon: Cpu },
  { href: "/team", label: "Users", icon: Users, clientSuperAdminOnly: true },
  { href: "/reports", label: "Reports", icon: FileBarChart },
  { href: "/settings", label: "Users & Settings", icon: Settings, adminOnly: true },
];

function normOrg(s) {
  return (s || "").trim().toLowerCase().replace(/\s+/g, " ").replace(/\s?-\s?/g, "-");
}

export function navItemsForRole(role, user) {
  return NAV_ITEMS.filter((i) => {
    if (i.adminOnly && role !== "admin") return false;
    if (i.clientSuperAdminOnly) {
      return role === "client_user" && user?.client_role === "super_admin";
    }
    if (i.href === "/sticks") {
      // Sticks: staff always in; client_user only if their org is T-Mobile.
      if (role === "admin" || role === "warehouse_staff") return true;
      if (role === "client_user" && normOrg(user?.client_name) === "t-mobile") return true;
      return false;
    }
    return true;
  });
}
